/* SIMILEA - convierte los titulos (h2/h3/h4) de la descripcion del producto en desplegables */
(function () {
  var HEADINGS = ['H2', 'H3', 'H4', 'H5'];
  var STYLE_ID = 'similea-acc-style';
  var scheduled = false;

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = [
      '.product__description .similea-acc{border-bottom:1px solid rgba(var(--color-foreground),0.15);}',
      '.product__description .similea-acc:first-of-type{border-top:1px solid rgba(var(--color-foreground),0.15);}',
      '.product__description .similea-acc__summary{list-style:none;cursor:pointer;display:flex;align-items:center;justify-content:space-between;gap:1rem;padding:1.4rem 0;font-family:var(--font-heading-family);font-weight:var(--font-heading-weight);font-size:1.5rem;letter-spacing:0.06rem;line-height:1.3;}',
      '.product__description .similea-acc__summary::-webkit-details-marker{display:none;}',
      '.product__description .similea-acc__summary:focus-visible{outline:0.2rem solid rgba(var(--color-foreground),0.5);outline-offset:0.3rem;}',
      '.product__description .similea-acc__icon{flex:0 0 auto;width:0.8rem;height:0.8rem;border-right:0.15rem solid currentColor;border-bottom:0.15rem solid currentColor;transform:rotate(45deg);transition:transform 0.2s ease;margin-right:0.4rem;}',
      '.product__description .similea-acc[open] .similea-acc__icon{transform:rotate(-135deg);}',
      '.product__description .similea-acc__content{padding:0 0 1.6rem;}',
      '.product__description .similea-acc__content > *:first-child{margin-top:0;}',
      '.product__description .similea-acc__content > *:last-child{margin-bottom:0;}',
      '.product__description .similea-acc__content ul{margin:0;padding-left:2rem;}',
      '.product__description .similea-acc__content li{margin-bottom:0.4rem;}',
      '.product__description .similea-acc__content table{width:100%;border-collapse:collapse;font-size:1.2rem;letter-spacing:0;}',
      '.product__description .similea-acc__content th,.product__description .similea-acc__content td{border:1px solid rgba(var(--color-foreground),0.15);padding:0.6rem 0.2rem;text-align:center;letter-spacing:0;word-break:normal;overflow-wrap:normal;hyphens:none;}',
      '.product__description .similea-acc__content th{font-weight:600;line-height:1.2;}'
    ].join('');
    document.head.appendChild(s);
  }

  function build(container) {
    if (!container || container.dataset.simileaAcc === '1') return;
    var nodes = Array.prototype.slice.call(container.childNodes);
    var hasHeading = nodes.some(function (n) {
      return n.nodeType === 1 && HEADINGS.indexOf(n.tagName) !== -1;
    });
    if (!hasHeading) return;
    container.dataset.simileaAcc = '1';

    var openFirst = window.matchMedia('(min-width: 750px)').matches;
    var frag = document.createDocumentFragment();
    var intro = document.createElement('div');
    var current = null;
    var count = 0;

    nodes.forEach(function (node) {
      if (node.nodeType === 1 && HEADINGS.indexOf(node.tagName) !== -1) {
        count++;
        var d = document.createElement('details');
        d.className = 'similea-acc';
        if (openFirst && count === 1) d.open = true;
        var sum = document.createElement('summary');
        sum.className = 'similea-acc__summary';
        var t = document.createElement('span');
        t.className = 'similea-acc__title';
        t.textContent = (node.textContent || '').trim();
        var ic = document.createElement('span');
        ic.className = 'similea-acc__icon';
        ic.setAttribute('aria-hidden', 'true');
        sum.appendChild(t);
        sum.appendChild(ic);
        var body = document.createElement('div');
        body.className = 'similea-acc__content';
        d.appendChild(sum);
        d.appendChild(body);
        frag.appendChild(d);
        current = body;
        return;
      }
      if (node.nodeType === 3 && !node.textContent.trim()) return;
      (current || intro).appendChild(node);
    });

    container.textContent = '';
    if (intro.childNodes.length) container.appendChild(intro);
    container.appendChild(frag);
  }

  function run() {
    scheduled = false;
    injectStyles();
    var list = document.querySelectorAll('.product__description');
    for (var i = 0; i < list.length; i++) build(list[i]);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', schedule);
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }
})();